module.exports = __webpack_public_path__ + "static/media/wp.ee2b6856.png";